// Static "People. Power. Purpose." used on auth pages. No animation —
// auth must feel fast. Each period is the rhythm-marker (ink @ 40% opacity).

const TOKENS = ['People', 'Power', 'Purpose'];

interface Props {
  className?: string;
  centered?: boolean;
}

export function BrandTagline({ className, centered = true }: Props) {
  return (
    <p
      aria-label="People. Power. Purpose."
      className={'font-display text-accent ' + (centered ? 'text-center' : '') + (className ?? '')}
      style={{
        fontSize: 'clamp(0.9rem, 1.4vw, 1.05rem)',
        letterSpacing: '0.02em',
        lineHeight: 1.2,
      }}
    >
      {TOKENS.map((tok, i) => (
        <span key={tok} className={i > 0 ? 'ml-1.5' : ''}>
          {tok}
          <span className="text-ink/40">.</span>
        </span>
      ))}
    </p>
  );
}
